import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cdf-button-row',
  template: `<ng-content />`,
  styles: `
    :host {
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      gap: var(--ds-space-2x) var(--ds-space-4x);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonRowComponent {}
